<template>
  <div id="home">
    <owlCarosel/>
    <items/>
    <router-view/>
  </div>

</template>
<script>

import owlCarosel from '@/components/home/owlCarosel.vue'
import items from '@/components/home/items.vue'
export default {
  name: 'home',
  components: {
    owlCarosel,
    items
  }
}
</script>

<style lang="scss">
body{
  overflow-x: hidden;
  background: #2e2c2c !important;

}
</style>
